import React from 'react'
import './Contact.scss'

export const Contact = () => {
  return (
    <div className='Contact' id='skills'>
      <div className="container">
        <div className="Contact__inside">
          <p>Let Me Get You A Beatiful Website.</p>
          <a href="https://www.linkedin.com/in/%D0%BA%D0%B0%D0%BD%D0%B0%D1%82-%D0%BA%D0%B0%D0%BC%D1%87%D1%8B%D0%B5%D0%B2-a08792268/  ]
" className='button-two'>Hire Me</a>
        </div>
      </div>
    </div>
  )
}
